import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay, EffectFade } from 'swiper/modules';
import { Link as ScrollLink } from 'react-scroll';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Nav from '../Nav/Nav.js';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade'; 
import "./Header.css";
import bg1 from "./Background1.png"

function Header() {
  const { t, i18n } = useTranslation();
    
        const changeLanguage = (e) => {
          i18n.changeLanguage(e.target.value);
      };
  const slideData = [
    {
      title: t('home.title1'),
      description: t('home.paragraph1'),
      bgImage: bg1,
    },
    {
      title: t('home.title2'),
  description: t('home.paragraph2'),
      bgImage: bg1 ,
    }
  ];

  return (
    <header className='header-wrapper'>
      <div className="nav-overlay">
        <Nav />
      </div>
      <Swiper
        pagination={{ clickable: true }}
        modules={[Pagination, Autoplay, EffectFade]}
        autoplay={{ delay: 5000 }}
        speed={1000}
        className="header-swiper"
      >
        {slideData.map((slide, index) => (
          <SwiperSlide key={index}>
            <div 
              className='slide-bg' 
              style={{ backgroundImage: ` url(${slide.bgImage})` }}
            >
              <div className='Header_all' data-aos="zoom-in">
                <div className='header_titles ar'>
                  <h1 className='titre'>{slide.title}</h1>
                  <h4 className='plf'>{slide.description}</h4>
                </div>
                <div className='buttons'>
                  <ScrollLink to="Apropos" smooth={true} duration={900} className='plf header_button1'>
                    {t('home.button1')}
                  </ScrollLink>
                  <RouterLink to="/Galerie" className='plf header_button2'>
                    {t('home.button2')}
                  </RouterLink>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </header>
  );
}

export default Header;